import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lexibox-info',
  templateUrl: './lexibox-info.component.html',
  styleUrls: ['./lexibox-info.component.scss']
})
export class LexiboxInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
